
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 400 400","width":"400","height":"400"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"200","cy":"200","r":"180","fill":"#333","stroke-width":"6","stroke":"#fff"}}),_c('path',{attrs:{"fill":"#fff","d":"M227.272 153.646v185.862h-57.15V153.646h-91.63V96.492h243.016l-21.947 57.154z"}})])
          )
        }
      }
    